import { createFeatureSelector, createSelector } from '@ngrx/store';

import { DeviceState } from './device.reducer';

export const getDeviceState = createFeatureSelector<DeviceState>('device');

export const getDeviceInfo = createSelector(
  getDeviceState,
  (state) => state.entity
);
